import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import TipCalculator from '../../components/TipCalculator';

const TipCalcPage: React.FC = () => (
  <ToolLayout
    title="Tip Calculator - Calculate Tips & Split Bills | AllTools"
    description="Calculate tips and split bills easily. Quick tip presets, custom percentages, and bill splitting for any group size. Free tip calculator."
    canonicalPath="/tip-calculator"
  >
    <TipCalculator />
  </ToolLayout>
);

export default TipCalcPage;
